import React from 'react';
import * as S from './SomethingWentWrong.styles';
import SomethingWentWrongIcon from './SomethingWentWrongIcon';

export default function SomethingWentWrong({
  headingStyles = {},
  suggestionStyles = {},
  actionTextStyles = {},
  containerStyles = {},
}) {
  return (
    <S.Container {...containerStyles}>
      <S.TextContainer>
        <S.Heading {...headingStyles}>Oops! Something went wrong</S.Heading>

        <S.SuggestionText {...suggestionStyles}>Please try refreshing the page</S.SuggestionText>

        <S.ActionText {...actionTextStyles}>
          <span>Go back to </span>

          <span>
            <a href="/flights/"> Flights</a>
          </span>

          <span> |</span>

          <span>
            <a href="/buses/"> Buses</a>
          </span>

          <span> |</span>

          <span>
            <a href="/hotels/"> Hotels</a>
          </span>

          <span> |</span>

          <span>
            <a href="/trains/"> Trains</a>
          </span>
        </S.ActionText>
      </S.TextContainer>
      <S.IconContainer>
        <SomethingWentWrongIcon />
      </S.IconContainer>
    </S.Container>
  );
}
